import styled from 'styled-components';

export const Wrapper = styled.div<{ $hasValue: boolean }>`
  .ant-select-selector {
    border: 1px solid
      ${({ theme, $hasValue }) => ($hasValue ? theme.colors.green7 : theme.colors.black4)} !important;
    background-color: ${({ theme, $hasValue }) =>
      $hasValue ? theme.colors.green2 : 'transparent'} !important;

    &:hover {
      border-color: ${({ theme }) => theme.colors.black4} !important;
      background-color: ${({ theme }) => theme.colors.green1} !important;
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }

    &:active {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }
  }

  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colors.black9} !important;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DropdownWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .option {
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black9};

    &:hover {
      background-color: ${({ theme }) => theme.colors.green1};
    }

    &.selected {
      background-color: ${({ theme }) => theme.colors.green2};
      color: ${({ theme }) => theme.colors.green7};
    }
  }
`;

export const DateRangeWrapper = styled.div`
  padding-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
`;
